//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'airPair',
  data () {
    return {
      id: 0,
      keyword: '',
      brands: [],
      currentBrand: null,
      currentCode: '',
      activeLetter: '',
      step: 'brand',
      temperature: 25,
      currentPower: 1
    }
  },
  created () {
    this.id = Number(this.$route.params.id)
    this.loadBrands()
  },
  computed: {
    letters () {
      return this.groupedBrands.map(item => item.letter)
    },
    groupedBrands () {
      let groups = {}
      this.brands.forEach(item => {
        let letter = this.brandLetter(item)
        if (!groups[letter]) {
          groups[letter] = []
        }
        groups[letter].push(item)
      })
      return Object.keys(groups).sort().map(letter => {
        return { letter: letter, items: groups[letter] }
      })
    },
    codes () {
      return this.currentBrand && this.currentBrand.codes ? this.currentBrand.codes : []
    },
    currentIndex () {
      return this.codes.indexOf(Number(this.currentCode))
    },
    remainingCount () {
      if (this.currentIndex < 0) {
        return this.codes.length
      }
      return Math.max(this.codes.length - this.currentIndex - 1, 0)
    },
    pairTitle () {
      return this.currentBrand ? '转换器（' + this.currentBrand.name + '）' : '空调配对'
    }
  },
  methods: {
    loadBrands () {
      this.$api.airConditionerModels({keyword: this.keyword}).then((res) => {
        if (res) {
          this.brands = res.data || []
          this.activeLetter = this.groupedBrands.length ? this.groupedBrands[0].letter : ''
        }
      })
    },
    brandLetter (item) {
      const letterMap = {
        '奥克斯': 'A',
        '澳柯玛': 'A',
        '宝立创': 'B',
        '春兰': 'C',
        '长虹': 'C',
        '创维': 'C',
        '东芝': 'D',
        '东宝': 'D',
        '大金': 'D',
        '富士通': 'F',
        '格力': 'G',
        '高路华': 'G',
        '格兰仕': 'G',
        '高美': 'G',
        '国美': 'G',
        '海尔': 'H',
        '海信': 'H',
        '华凌': 'H',
        '惠而浦': 'H',
        '海林': 'H',
        '海普': 'H',
        '华蒜': 'H',
        '和山': 'H',
        '科龙': 'K',
        '开利': 'K',
        '康佳': 'K',
        '酷风': 'K',
        '蓝波': 'L',
        '乐华': 'L',
        '乐京': 'L',
        '美的': 'M',
        '麦克维尔': 'M',
        '米家': 'M',
        '内田': 'N',
        '欧科': 'O',
        '日立': 'R',
        '三星': 'S',
        '三洋': 'S',
        '三菱重工': 'S',
        '三菱电机': 'S',
        '松下': 'S',
        '上凌': 'S',
        '三垦': 'S',
        '三菱': 'S',
        '上菱': 'S',
        '绅宝': 'S',
        '深松': 'S',
        '深宝': 'S',
        '三菱重工海尔': 'S',
        '山水': 'S',
        '苏宁极物': 'S',
        '天元': 'T',
        '泰阳': 'T',
        '汤姆森': 'T',
        '万宝': 'W',
        '新科': 'X',
        '熊猫': 'X',
        '夏普': 'X',
        '新迎燕': 'X',
        '夏洋': 'X',
        '西冷': 'X',
        '小米': 'X',
        '夏宝': 'X',
        '乐声': 'Y',
        '玉兔': 'Y',
        '扬子': 'Y',
        '伊莱克斯': 'Y',
        '约克': 'Y',
        '樱花': 'Y',
        '月兔': 'Y',
        '银燕': 'Y',
        '志高': 'Z',
        '镇堡': 'Z',
        '中广欧特斯': 'Z'
      }
      if (letterMap[item.name]) {
        return letterMap[item.name]
      }
      let en = (item.en || item.name || '').trim()
      let letter = en ? en.substr(0, 1).toUpperCase() : '#'
      return /^[A-Z]$/.test(letter) ? letter : '#'
    },
    scrollToLetter (letter) {
      this.activeLetter = letter
      let el = document.getElementById('brand-' + letter)
      if (el) {
        el.scrollIntoView()
      }
    },
    selectBrand (item) {
      this.currentBrand = item
      this.currentCode = item.codes && item.codes.length ? item.codes[0] : ''
      this.currentPower = 1
      this.step = 'control'
    },
    sendPairCommand (power) {
      if (!this.currentCode) {
        this.$func.showToast('请选择空调型号码')
        return false
      }
      this.$func.startLoading('请求中。。。')
      this.$api.airPairControl({
        id: this.id,
        ac_code: this.currentCode,
        power: power,
        temperature: this.temperature,
        mode: 0,
        fan: 1
      }).then((res) => {
        if (res.code == 0) {
          this.$func.showToast('发送成功')
        }
        this.$func.endLoading()
      })
    },
    nextCode () {
      if (this.codes.length <= 0) {
        return false
      }
      let index = this.currentIndex
      if (index < 0) {
        this.currentCode = this.codes[0]
        return false
      }
      if (index >= this.codes.length - 1) {
        this.$func.showToast('当前品牌已到最后一组')
        return false
      }
      this.currentCode = this.codes[index + 1]
      this.currentPower = 1
    },
    saveCode () {
      if (!this.currentCode) {
        this.$func.showToast('请选择空调型号码')
        return false
      }
      if (this.currentPower) {
        this.currentPower = 0
        return false
      }
      this.$func.startLoading('请求中。。。')
      this.$api.airSaveModelCode({
        id: this.id,
        ac_code: this.currentCode,
        brand: this.currentBrand ? this.currentBrand.name : ''
      }).then((res) => {
        if (res.code == 0) {
          this.$func.showToast('保存成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 300)
        }
        this.$func.endLoading()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/airPair.vue